import { getAnalytics, isSupported } from "firebase/analytics";
import { app } from "../firebase/firebaseConfig";

let analytics = null;

export const initAnalytics = async () => {
  if (typeof window !== "undefined") {
    const supported = await isSupported();
    if (supported) {
      analytics = getAnalytics(app);
    }
  }
};

export const getAnalyticsInstance = () => analytics;